module.exports = __webpack_public_path__ + "img/green.d89a4fa1.png";